import { getIsJapan } from '../utils/getIsJapan';
export const shouldAddOptionalPhoneNumber = state => {
  return getIsJapan(state);
};